<template>
  <router-view/>
</template>

<style>
/** global stylings */

* {
  font-family: monospace;
}

:root {
  --main-color: #da8dff;
}

.fs {
  width: 100vw;
  height: 100vh;
  padding: 0px;
  margin: 0px;
  position: absolute;
  top: 0px;
  left: 0px;
}

</style>
